
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/samples/palette",
      function () {
        return require("private-next-pages/samples/palette.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/samples/palette"])
      });
    }
  